import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { PlayButtonP } from '@app/modules/audit/modules/station-audit/components/audit-result/PlayButton';
import { toTimestamp } from '@mi-front/core';
import { LowerthirdType } from '../screens/lowerthird/types';
import { Station } from '@app/core/types/stations';

export function PlayLowerthirdButton(p: { lowerthird: LowerthirdType; station: Station }) {
  const play = usePlaybackPlay();

  const handlePlay = () => {
    const startTs = toTimestamp(p.lowerthird.from);
    const stopTs = toTimestamp(p.lowerthird.to);

    play({
      startTs,
      stopTs,
    });
  };

  return <PlayButtonP play={handlePlay} />;
}
